import React from "react";
import ReactTable from "react-table";
import Chart from "react-google-charts";
import { toast } from "react-toastify";
import copysvg from "./../../assets/arrow_copy.svg";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ManagersFacilitatorKRAGrid(props)
{
    const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	  };

    const generateColumns=(FacilitatorData)=>{

        if(!FacilitatorData)
        {
            return [];
        } 

        let ColumnName=[];        
        FacilitatorData.map((x) => 
        {
            props.selectedFacilitatorNameListForFilter.map((d) => {
                if(d.value!="*")
                {
                    if(d.value===x.facilitator_email)
                    {
                        ColumnName.push({facilitator_name:x.facilitator_name,facilitator_email:x.facilitator_email});
                    }
                }
            });
            
        });

        const columns = /*[];        
        var columnStatus={
            
            columns:*/ [
                {
                    id: "reportType",
                    Header: "",
                    width:110,
                    fixed: "left",
                    accessor: "reportType",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                    style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: {
                                borderLeft: 'solid 1px #ccc',	
                                borderRight:'solid 1px #ccc',				
                            },
                        };
                    },					
                },
                {
                    id: "Title",
                    Header: "",
                    width:300,
                    fixed: "left",
                    accessor: "Title",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                    style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: {
                                borderLeft: 'solid 1px #ccc',	
                                borderRight:'solid 1px #ccc',				
                            },
                        };
                    },
                },
                {
                    id: "target",
                    Header: "Target",
                    accessor: "target",
                    width:110,
                    fixed: "left",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                    style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: {
                                borderLeft: 'solid 1px #ccc',	
                                borderRight:'solid 1px #ccc',				
                            },
                        };
                    },
                },
            ]
        /*}*/
            
        let ServiceColumnsName= ColumnName.map((x) => 
        {
            return {
                id: x.facilitator_email,
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                Header: x.facilitator_name,
                accessor: x.facilitator_email.replace(/ /g, '').replace(/\./g,''),
                width: 250,
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            borderLeft: 'solid 1px #ccc',	
                            borderRight:'solid 1px #ccc',				
                        },
                    };
                },
                Cell: ({ original }) =>(
                    original["key"]==="quality_analysis_fatal_count"?
                    (
                        <a
                            style={{ textDecoration: "underline" }}
                            title={`${
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'serinstanceids')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'serinstanceids']}${'\n'}${
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'fataldetails')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'fataldetails']}`}
                        >
                        {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}
                        </a>
                    ):
                    original["key"]==="arr_three_resourses_availed_users"?
                    (
                        <>
                            {
                                original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&
                                (parseInt(original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')])>0)?
                                (
                                    <img
                                        alt="copy"
                                        src={copysvg}
                                        height={"20px"}
                                        width={"16px"}
                                        className="con-cursor-pointer conv-mr13"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails')&&
                                            original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails'].toString().replace(/,/g, '\n'));
                                            toast('Users Email Copied!', {
                                                autoClose: 5000,
                                                type: toast.TYPE.SUCCESS,
                                            });
                                        }}
                                    />
                                ):("")
                            }                            
                            <a
                                style={{ textDecoration: "underline" }}
                                title={`${
                                        original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails')&&
                                        original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails'].toString().replace(/,/g, '\n')}${'\n'}`}
                            >
                                {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}
                            </a>
                        </>
                        
                    ):
                    original["key"]==="arr_two_resourses_availed_users"?
                    (
                        <>
                            {
                                original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&
                                (parseInt(original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')])>0)?
                                (
                                    <img
                                        alt="copy"
                                        src={copysvg}
                                        height={"20px"}
                                        width={"16px"}
                                        className="con-cursor-pointer conv-mr13"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails')&&
                                            original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails'].toString().replace(/,/g, '\n'));
                                            toast('Users Email Copied!', {
                                                autoClose: 5000,
                                                type: toast.TYPE.SUCCESS,
                                            });
                                        }}
                                    />
                                ):("")
                            }                            
                            <a
                                style={{ textDecoration: "underline" }}
                                title={`${
                                        original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails')&&
                                        original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails'].toString().replace(/,/g, '\n')}${'\n'}`}
                            >
                                {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}
                            </a>
                        </>
                        
                    ):
                    original["key"]==="targeted_vs_achieved"?
                    (
                        <Chart
                            width={'150px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'target')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'target']||0,
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'achieved')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'achieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { width: '100px' },
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    original["key"]==="delivered_services_target_vs_achieved"?
                    (
                        <Chart
                            width={'220px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredtarget')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredtarget']||0,
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredachieved')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredachieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { left:10,width: '55%'},
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    original["key"]==="three_resourses_availed_users_target_vs_achieved"?
                    (
                        <Chart
                            width={'220px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeuserstarget')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeuserstarget']||0,
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeusersachieved')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeusersachieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { left:10,width: '55%' },
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    (
                        original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]
                    )
                )
				,
            };
        });

        ColumnName.map((x) => 
        {
            columns.push(
             {
                id: x.facilitator_email,
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                Header: x.facilitator_name,
                accessor: x.facilitator_email.replace(/ /g, '').replace(/\./g,''),
                width: 250,
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            borderLeft: 'solid 1px #ccc',	
                            borderRight:'solid 1px #ccc',				
                        },
                    };
                },
                Cell: ({ original }) =>(
                    original["key"]==="quality_analysis_fatal_count"?
                    (
                        <a
                            style={{ textDecoration: "underline" }}
                            title={`${
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'serinstanceids')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'serinstanceids']}${'\n'}${
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'fataldetails')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'fataldetails']}`}
                        >
                        {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}
                        </a>
                    ):
                    original["key"]==="arr_three_resourses_availed_users"?
                    (
                        <>
                            {
                                original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&
                                (parseInt(original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')])>0)?
                                (
                                    <img
                                        alt="copy"
                                        src={copysvg}
                                        height={"20px"}
                                        width={"16px"}
                                        className="con-cursor-pointer conv-mr13"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails')&&
                                            original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails'].toString().replace(/,/g, '\n'));
                                            toast('Users Email Copied!', {
                                                autoClose: 5000,
                                                type: toast.TYPE.SUCCESS,
                                            });
                                        }}
                                    />
                                ):("")
                            }                            
                            <a
                                style={{ textDecoration: "underline" }}
                                title={`${
                                        original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails')&&
                                        original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeresoursesavaileduseremails'].toString().replace(/,/g, '\n')}${'\n'}`}
                            >
                                {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}
                            </a>
                        </>
                        
                    ):
                    original["key"]==="arr_two_resourses_availed_users"?
                    (
                        <>
                            {
                                original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&
                                (parseInt(original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')])>0)?
                                (
                                    <img
                                        alt="copy"
                                        src={copysvg}
                                        height={"20px"}
                                        width={"16px"}
                                        className="con-cursor-pointer conv-mr13"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails')&&
                                            original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails'].toString().replace(/,/g, '\n'));
                                            toast('Users Email Copied!', {
                                                autoClose: 5000,
                                                type: toast.TYPE.SUCCESS,
                                            });
                                        }}
                                    />
                                ):("")
                            }                            
                            <a
                                style={{ textDecoration: "underline" }}
                                title={`${
                                        original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails')&&
                                        original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'tworesoursesavaileduseremails'].toString().replace(/,/g, '\n')}${'\n'}`}
                            >
                                {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}
                            </a>
                        </>
                        
                    ):
                    original["key"]==="targeted_vs_achieved"?
                    (
                        <Chart
                            width={'150px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'target')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'target']||0,
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'achieved')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'achieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { width: '100px' },
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    original["key"]==="delivered_services_target_vs_achieved"?
                    (
                        <Chart
                            width={'220px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredtarget')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredtarget']||0,
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredachieved')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'deliveredachieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { left:10,width: '55%'},
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    original["key"]==="three_resourses_availed_users_target_vs_achieved"?
                    (
                        <Chart
                            width={'220px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeuserstarget')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeuserstarget']||0,
                                    original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeusersachieved')&&
                                    original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')+'threeusersachieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { left:10,width: '55%' },
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    original["key"]==="assigned_customers"?
                    (
                        <>
                            {original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]}

                            <span
                                style={{ "textDecoration": "underline","color":"blue",marginLeft:"5px" }} 
                                onClick={() =>props.fetchFacilitatorCallReport(x.facilitator_email)}
                            >
                                Introductory Call Report                            
                            </span>
                        </>
                        
                    )
                    :
                    (
                        original.hasOwnProperty(x.facilitator_email.replace(/ /g, '').replace(/\./g,''))&&original[x.facilitator_email.replace(/ /g, '').replace(/\./g,'')]
                    )
                )
				,
            })
        });

        var dsd={
            columns: ServiceColumnsName,
        };
        //columns.push(columnStatus);
        //columns.push(dsd);
        return columns;
	}

    return (
        <ReactTableFixedColumns
            data={props.data || []}
            columns={generateColumns(props.FacilitatorData)}
            pageSize={20}
            sortable={false}
            showPagination={false}
            style={{overflowY: "auto",height: "450px"}}	
            className="-striped"
        />
    );
}